import t from "./_Symbol.js";
import e from "./_getRawTag.js";
import o from "./_objectToString.js";
var i = "[object Null]", f = "[object Undefined]", r = t ? t.toStringTag : void 0;
function m(n) {
  return n == null ? n === void 0 ? f : i : r && r in Object(n) ? e(n) : o(n);
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseGetTag.js
// module id = 211
// module chunks = 67